import styled from 'styled-components';
import Sider from 'antd/es/layout/Sider';
import { Tag } from 'antd';

export const StyledSider = styled(Sider)`
  background-color: white !important;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 85vh;
`;

export const StyledFiltersTag = styled(Tag)`
  border-radius: 12px;
  justify-content: flex-start;
`;

export const StyledLink = styled.a`
  display: flex;
  padding: 3px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  color: #1890ff; /* Link color */
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const StyledLinksContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-left: auto; /* Pushes the links to the right */
`;

export const StyledFilterHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  margin-bottom: 16px;
`;

export const StyledFilterTitle = styled.span`
  font-size: 16px;
  font-weight: bold;
  margin-right: 4px;
`;
